/**
 * The plan no longer schedules this stored Visit's occurrence (stored as `reviewConflict`). The header tag pipeline carries a label and colours
 * only — no tooltip channel — so the reason rides in the label rather than being dropped.
 */
import { VisitBrowseRow } from '@jms/model';
import { defineConditionalTag } from '../../shared/define.conditional.tag';

/** The "No longer scheduled: <reason>" pill on the Visit header and board card. */
export const visitNoLongerScheduledTag = defineConditionalTag<VisitBrowseRow>(row => {

  if (!row.noLongerScheduled) return null;
  const reason = row.reviewReason?.trim();
  return { label: reason ? `No longer scheduled: ${reason}` : 'No longer scheduled', tone: 'warning' };
});
